import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Interviews {
	/**
	 * @path /pages/:pgid/positions/:pid/interviews
	 * @param pid
	 * @returns
	 */
	async getAllInterviews(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], token: string) {
		return xget<{ interviews: PGSchema.interviews[]; inter_counts: Record<string, number> }>(`/pages/${pgid}/positions/${pid}/interviews`, {}, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid/interviews
	 * @param pid
	 * @returns
	 */
	async getInterview(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], iid: string, token: string) {
		return xget<{ interview: PGSchema.interviews; skills: PGSchema.interview_skills[] }>(`/pages/${pgid}/positions/${pid}/interviews/${iid}`, {}, { headers: { "app-token": token! } });
	}
	/**
	 * @path /pages/:pgid/positions/:pid/interviews
	 * @param interview: Partial<PGSchema.interviews>
	 * @returns { interview: PGSchema.interviews }
	 */
	async createInterview(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], interview: Partial<PGSchema.interviews>, token: string) {
		return xhttp<{ interview: PGSchema.interviews }>(`/pages/${pgid}/positions/${pid}/interviews`, "POST", interview, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid/interviews/:iid
	 * @param interview: Partial<PGSchema.interviews>
	 * @param token: string
	 * @param id: string
	 * @returns { interview: PGSchema.interviews }
	 */
	async updateInterview(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], iid: string, interview: Partial<PGSchema.interviews>, token: string) {
		return xhttp<{ interview: PGSchema.interviews }>(`/pages/${pgid}/positions/${pid}/interviews/${iid}`, "PUT", interview, { headers: { "app-token": token! } });
	}
	/**
	 * @path /pages/:pgid/positions/:pid/interviews/:iid
	 * @param id: string
	 * @param token: string
	 * @returns { interview: PGSchema.interviews }
	 */
	async deleteInterview(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], iid: string, token: string) {
		return xhttp<{ interview: PGSchema.interviews }>(`/pages/${pgid}/positions/${pid}/interviews/${iid}`, "DELETE", {}, { headers: { "app-token": token! } });
	}

	/**
	 * @path /pages/:pgid/positions/:pid/interviews/clone
	 * @description Clone PG interviews from one job to another within the same page
	 */
	async cloneInterviewsFromJob(pgid: PGSchema.pages["id"], targetPid: PGSchema.jobs["job_id"], sourcePid: PGSchema.jobs["job_id"], interviewsIds: string[], token: string) {
		return xhttp<{ message: string; interviews: PGSchema.interviews[] }>(
			`/pages/${pgid}/positions/${targetPid}/interviews/clone`,
			"POST",
			{ source_pid: sourcePid, interviews_ids: interviewsIds },
			{ headers: { "app-token": token! } }
		);
	}

	/**
	 * @path /pages/:pgid/positions/:pid/interviews
	 * @param interview: Partial<PGSchema.interviews>
	 * @returns { interview: PGSchema.interviews }
	 */
	async migrateInterview(pgid: PGSchema.pages["id"], pid: PGSchema.jobs["job_id"], interviewsIds: number[], token: string) {
		return xhttp<{ interview: PGSchema.interviews }>(
			`/pages/${pgid}/positions/${pid}/interviews/migrate`,
			"POST",
			{
				interviews_ids: interviewsIds
			},
			{ headers: { "app-token": token! } }
		);
	}
}
